import FdCalculator from '@components/Calculators/fd';
import { getCalculatorsDefaultValues } from '@components/Calculators/helpers';
import { calculatorSlugs } from '@components/Calculators/helpers/constants';
import texts from '@components/Products/FixedDeposits/en.json';
import { Text } from '@ui/atoms';
import Button from '@ui/atoms/design-system/Button';

const FDCalculatorContainer = ({ handleOnClick }) => {
    const { totalInvestment, rate, time } = getCalculatorsDefaultValues(
        calculatorSlugs.FD_CALCULATOR
    );
    return (
        <div className="px-4 py-12 bg-basicWhite xl:mt-[72px]">
            <Text
                content={texts.fdCalculator.heading}
                className="h4-semibold md:h3-semibold xl:h2-semibold text-center text-primary-500"
                htmlTag="h2"
            />
            <Text
                content={texts.fdCalculator.description}
                className="p4-regular xl:p2-regular text-center text-gray-600 mt-2 xl:mt-4"
            />
            <div className="pt-6 max-w-[880px] mx-auto">
                <FdCalculator
                    totalInvestment={totalInvestment}
                    rate={rate}
                    time={time}
                    handleOnClick={handleOnClick}
                />
            </div>
            <div className="flex justify-center items-center mt-6 xl:hidden">
                <Button
                    onClick={handleOnClick}
                    id="bookFd"
                    buttonSize="large"
                    buttonText={texts?.bookFdNow}
                />
            </div>
        </div>
    );
};

export default FDCalculatorContainer;
